import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ClientForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post("https://tj.marenergy.ro/api.php", {
        action: "add_client",
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
      })
      .then(() => {
        navigate("/clients"); // Redirecționează la lista de clienți după adăugare
      })
      .catch(() => {
        setError("Eroare la adăugare client");
      });
  };

  return (
    <div className="container">
      <h1 className="text-center my-4">Adaugă Client</h1>
      {error && <p className="text-danger text-center">{error}</p>}
      <div className="card p-4 shadow mt-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Nume:</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label>Telefon:</label>
            <input
              type="text"
              name="phone"
              className="form-control"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Adaugă Client
          </button>
        </form>
      </div>
    </div>
  );
};

export default ClientForm;